module.exports = __webpack_public_path__ + "static/media/hand-receiving.7609c32f.svg";